module.exports = __webpack_public_path__ + "static/media/service.a0ebd144.png";